import { Component, OnInit, OnDestroy } from "@angular/core";
import
  {
    WebCustomer,
    WebCustomerAgingVariables,
  } from "src/app/models";
import { Subscription } from "rxjs";
import { ApsService, ContactService, CompanyService, CustomerService, SharedService } from "src/app/services";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { APSMaster } from "src/app/models";
import { SessionDataService } from "src/app/services/session-data.service";
import { ContactListDialogComponent } from "./contact-list-dialog/contact-list-dialog.component";
import { UpdatePasswordDialogComponent } from "./update-password-dialog/update-password-dialog.component";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-account-details",
  templateUrl: "./account-details.component.html",
  styleUrls: ["./account-details.component.scss"],
})
export class AccountDetailsComponent implements OnInit, OnDestroy
{
  title: string = "";
  customer: WebCustomer;
  customerSubscription: Subscription;
  balanceDetailColor: string;

  isEmployee: boolean;
  customerAging: WebCustomerAgingVariables;
  customerAgingSubscription: Subscription;
  private availableBanksSubscription: Subscription;
  public availableBanks: APSMaster[];

  private availableCardsSubscription: Subscription;
  public availableCards: APSMaster[];

  constructor(
    private customerService: CustomerService,
    private contactService: ContactService,
    private companyService: CompanyService,
    public sessionDataService: SessionDataService,
    private dialog: MatDialog,
    public apsService: ApsService,
    private sharedService: SharedService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit(): void
  {
    this.customerSubscription = this.customerService.customer.subscribe(
      customer =>
      {
        this.customer = customer;
      });

    this.customerAgingSubscription = this.customerService.customerAging.subscribe(
      customerAging =>
      {
        this.customerAging = customerAging;
        this.balanceDetailColor = customerAging.DisplayBalanceColorHex;

        if (this.balanceDetailColor === "#FFFFFF" && !this.sharedService.isDark)
        {
          this.balanceDetailColor = "";
        }
      });

    this.availableBanksSubscription = this.apsService.availableBanks.subscribe(
      (banks) =>
      {
        this.availableBanks = banks;
      }
    );
    this.isEmployee = this.sessionDataService.IsEmployee;

    this.availableCardsSubscription = this.apsService.availableCards.subscribe(
      (cards) =>
      {
        this.availableCards = cards;
      }
    );
    this.routeUser();
  }
  async routeUser(): Promise<void>
  {
    await new Promise((r) => setTimeout(r, 1000));
    if (this.contactService.checkEmails())
    {
      this.dialog.open(ContactListDialogComponent, {
        disableClose: true,
        width: "600px",
        maxHeight: "90%",
        maxWidth: "90%",
      });
    }
  }
  updatePassword(): void
  {
    this.dialog.open(UpdatePasswordDialogComponent, {
      minWidth: 100,
      maxWidth: "600px",
      maxHeight: "500px",
      disableClose: true,
    });
  }
  isAutoPaySignUpAvailable(): boolean
  {
    return this.companyService.isAutopayAvailable && (this.availableBanks.length > 0 || this.availableCards.length > 0)
  }

  ngOnDestroy(): void 
  {
    this.customerSubscription?.unsubscribe();
    this.customerAgingSubscription?.unsubscribe();
    this.availableBanksSubscription?.unsubscribe();
    this.availableCardsSubscription?.unsubscribe();
  }
}
